import React, { Component } from 'react';
import Styles from "../../styles/Styles";

export default class ThirdSection extends Component {
  constructor(props) {
   super(props);

    this.state = {
    };
  }

  render() {

    return (
      <div className="section">
        <h2 style={Styles.Style.bgColorSecondary} className="section-title">Conditions tarifaires</h2>
        <div id="ThirdSection" className="row">
          <div className="mycol-4">
            <div className="card card-use-margin">
              <h4 style={Styles.Style.bgColorMain} className="card-heading">
                Droit d'adhésion
                <label className="price">Offert</label>
              </h4>
              <div className="card-body text-center card-list card-large">
                <ul>
                  <li>Ouverture administrative du compte et paramétrage</li>
                  <li>Ouverture de l’hébergement pour la base de données Clients</li>
                  <li>Inscription de l’officine sur la liste du site Internet www.paraprivilege.com et les applications mobiles</li>
                  <li>Assistance téléphonique de Mes avantages PARA pour le démarrage (formation sur site optionnelle : 750 € HT)</li>
                  <li>Envoi d’un kit de théâtralisation du point de vente</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mycol-4">
            <div className="card card-use-margin">
              <h4 style={Styles.Style.bgColorMain} className="card-heading">
                Abonnement mensuel
                <label className="price">99€ HT</label>
              </h4>
              <div className="card-body text-center card-list card-large">
                <ul>
                  <li>Hotline Mes avantages PARA</li>
                  <li>Hébergement de la base de données</li>
                  <li>Interfaçage du LGO compatible avec le module</li>
                  <li>Exploitation technique, maintenance des systèmes et des interfaces</li>
                  <li>Exploitation du moteur de calcul de points paramétrable</li>
                  <li>Création et gestion des comptes clients (comptabilité des achats points)</li>
                  <li>Droit d’utilisation de l’extranet CartePara.com</li>
                  <li>Suivi des performances du programme et traitement statistique mensuel</li>
                  <li>Traitement des anomalies, doublons, etc.</li>
                  <li>Abonnement prélevé en début de mois.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="mycol-4">
            <div className="card card-use-margin">
              <h4 style={Styles.Style.bgColorMain} className="card-heading">
                Cartes
                <label className="price">0,95€ HT / carte</label>
                <label>Validité 12 mois</label>
              </h4>
              <div className="card-body text-center card-list card-large">
                <ul>
                  <li>Les Packs de cartes comportent tous les éléments nécessaires au lancement du programme dans votre pharmacie.</li>
                  <li>Fourniture d’une carte PVC</li>
                  <li>Livret de Bienvenue</li>
                  <li>Interception des doublons</li>
                  <li>Envoi d’un e-mail de bienvenue au programme</li>
                  <li>Envoi d’un email anniversaire</li>
                  <li>Envoi d’email(s) de fidélité</li>
                  <li>Envoi d’un email carte à renouveler</li>
                  <li>Mémo de procédures</li>
                  <li>Renouvellement pour 12 mois sans perte de données lorsque le client revient faire des achats</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div className="card card-use-margin card-full-width">
            <h4 style={Styles.Style.bgColorMain} className="card-heading-small">
              Envoi des avantages du programme aux clients
            </h4>
            <div className="card-body text-center card-list card-small">
              <div className="row">
                <div className="mycol-4 card-small-content" >
                  Envoi par e-mail : <span class="line-through">0,08€ HT / email</span> PRIS EN CHARGE
                </div>
                <div className="mycol-4 card-border-left card-small-content">
                  En l'absence d'adresse e-mail personnelle : <br/>
                  Envoi par SMS : 0,12€ HT / SMS
                </div>
                <div className="mycol-4 card-border-left card-small-content">
                  En l'absence d'adresse e-mail personnelle et de numéro de téléphone mobile : <br/>
                  Envoi par courrier : 0,74€ HT / Courrier <br/>
                  (tarif métropole)
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center margin-top-l">
          <button style={Styles.Style.bgColorSecondary} className="btn btn-lg btn-primary-primary" onClick={this.props.onButtonClicked}>Adhérer au programme</button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/SellingPage/ThirdSection.js